/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../redux/store';

/**
 * Internal Imports
 */
import AdhocEmployeesTable from '../../components/customTables/employees/adhocEmployeesTable';
import SearchHeader from '../../components/searchHeader';

import { useGetEmployeesToRoundQuery } from '../../redux/apis/Users.api';

/**
 * Style Imports
 */
import { EmployeeContainer } from './styles/Employee.styles';

export interface EmployeeAdHocListProps {
  selectedDelegate: string;
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const EmployeeAdHocList: FC<EmployeeAdHocListProps> = ({
  selectedDelegate,
  searchTerm,
  setSearchTerm
}) => {
  const {
    data: employeesToRoundData,
    // isError: isGetEmployeesToRoundError,
    // isFetching: isGetEmployeesToRoundFetching,
    isLoading: isGetEmployeesToRoundLoading
  } = useGetEmployeesToRoundQuery(
    {
      hcaid: selectedDelegate,
      directReportsOnly: false
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !selectedDelegate || selectedDelegate.length !== 7
    }
  );

  return (
    <EmployeeContainer data-testid="adhoc-employee-view">
      <div className="d-flex flex-column w-100">
        <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <AdhocEmployeesTable
          adhocEmployees={employeesToRoundData ?? []}
          isLoading={isGetEmployeesToRoundLoading}
          searchTerm={searchTerm}
        />
      </div>
    </EmployeeContainer>
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    selectedDelegate: state.EmployeeReducer.selectedDelegatedEmployee.hcaid
  };
};

export default connect(mapReduxStateToProps)(EmployeeAdHocList);
